import gql from 'graphql-tag'
import { productMain, options, properties, lists, intervals } from '../fragments'

export default gql`
	mutation createProduct($required: ProductReqFields!, $fields: ProductFields, $copyId: ID) {
		cashAssist {
			createMutation: createProduct(required: $required, fields: $fields, copyId: $copyId) {
				id
				mod_ver
				...productmain
				...options

				img {
					uid
					key
				}
				imgKiosk {
					uid
					key
				}
				priceDiffMode
				specialPrices {
					id
					type
					typeName
					fromDate
					toDate
					name
				}
				...properties
				cashRegisterId
				category {
					name
					id
					color
					position
				}
				printChosenSubProducts
				printChosenSubProductsFlag
				fixProductsAutoSelect
				isPricesNormalByDefaultInSet
				isFastSelection
				isForTasting
				setsMode
				sets {
					category {
						id
						name
						gridProducts {
							product {
								id
								code
								name
							}
						}
					}
					minQuantity
					maxQuantity
					priceLevel
					isCollectPoints
					weekDays
					fixProducts {
						code
						amount
						price
					}
				}
				...lists
				...intervals
				isWeighted
				isTareInLabelMode
				tare
				EANCode
				EANstatistics
				cardChargeAmount
				cardSurchargePercent
				cardSurchargeFrom
				discount
				points {
					type
					quantity
					points
				}
				pointsCost
				pointsPriceLevel
				isInventory
				inventoryUnit
				minOrder
				numberPerUnit
				nameInOrder
				canCopy
				orderUnit
				visibleStatus
				bakeryReturn
				bakeryReturnEndOfDay
				bakeryStock
				FA_ProductId
			}
		}
	}
	${productMain}
	${options}
	${properties}
	${lists}
	${intervals}
`
